export const API_HOST =
  process.env.NEXT_PUBLIC_API_HOST ?? 'http://127.0.0.1:3001'
export const IMPORT_CLIENTS_FILE_URL = `${API_HOST}/static/template-importacao-clientes-18.xlsx`
export const IMPORT_DEMANDS_FILE_URL = `${API_HOST}/static/template-importacao-demandas.xlsx`
export const TOKEN_KEY = process.env.NEXT_PUBLIC_TOKEN_KEY ?? 't_c_tkn'
export const SUPPORT_INTERNAL_COMPANY_ID = (() => {
  const value = process.env.NEXT_PUBLIC_SUPPORT_INTERNAL_COMPANY_ID
  const parsedValue = Number(value)

  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null
})()

export const placeholderImageURL = '/image-placeholder.jpg'

export const DRAWER = {
  STATUS_KEY: 'drawer-status',
  OPEN_OFFSET: '320px',
  CLOSED_OFFSET: '145px',
}

export const TRANSMISSION_LIST_CONTACTS_LIMIT = 245
export const COMMEMORATIVE_MESSAGES_ALLOWED_COMPANY_ID = 97

export const MAX_CSAT_SCORE = 5

export const MAX_FILE_SIZE = 100 * 1024 * 1024 // 100MB
export const MEDIA_UPLOAD_HELP_TEXT =
  'Imagens, vídeos, áudios e documentos (ex.: JPG, PNG, MP4, MP3, PDF, DOCX). Limite de 100 MB por arquivo.'
export const MEDIA_UPLOAD_TOO_LARGE_MESSAGE =
  'O arquivo excede o limite de 100 MB e foi ignorado'

export const NAME_NOT_IDENTIFIED = '?'

export const EXTERNAL_DEVICE_MESSAGE_CONTEXT_LABEL = 'Dispositivo externo'

export const REFERRER_CLIENT_ORIGIN_VALUE = '0'

export const MIDNIGHT_TIME_ISO = 'T00:00:00'

export const CONVERSATION_TABS = {
  NOTES_TAB: 0,
  DEMANDS_TAB: 1,
  DEMAND_HISTORY_TAB: 2,
  CLIENT_INFO_TAB: 3,
  SETTINGS_TAB: 4,
  INTEGRATIONS_TAB: 5,
}

export const GCLICK_ENABLED = process.env.NEXT_PUBLIC_GCLICK_ENABLED === 'true'
export const OMIE_ENABLED = process.env.NEXT_PUBLIC_OMIE_ENABLED === 'true'

export const DISCONNECTED_UNKNOWN_NUMBER_TOAST_ID =
  'disconnected-unknown-number'

export * from './routes'
export * from './settings'
export * from './utils'
export * from './types'
export * from './roles'
export * from './validation'
export * from './endpoints'
export * from './status'
export * from './opportunities'
export * from './apiErrors'
export * from './countryCodes'
export * from './catalog'
export * from './tasks'
